import { render, staticRenderFns } from "./car-info.vue?vue&type=template&id=45c31e88"
import script from "./car-info.vue?vue&type=script&lang=js"
export * from "./car-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CarTech: require('/var/www/components/car/car-tech.vue').default,CarComplectation: require('/var/www/components/car/car-complectation.vue').default,CarBenefits: require('/var/www/components/car/car-benefits.vue').default})
